<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="banner-container">
      <div class="banner-image">
          <img src="@/assets/banner-logo.webp" alt="">
      </div>
    </div>
  </template>
  
  <script>
  export default {

  }
  </script>
  
  <style scoped>
  .banner-container {
    background-color: var(--primary-color);
    background-size: cover;
    background-position: center;
    text-align: center;
    width: 80vw;
    margin: auto;
    margin-top: 90px;
    margin-bottom: 30px;
    border: solid 2px;
    border-color: var(--border-color);
    border-radius: 20px;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .banner-text {
    color: #FEFAE0; /* Colore testo */
  }
  
  .banner-text h1 {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  .banner-text p {
    font-size: 16px;
    line-height: 1.6;
  }
  .banner-container img {
    width: 100%;
    border-radius: 20px;
  }
  </style>
  